import validateBknNum from '@/helpers/validateBknNum'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    return validateBknNum(value)
  }
}
